module.exports = __webpack_public_path__ + "img/z4.d0a51a10.png";